import axios from 'axios'
import {ElMessage, ElMessageBox} from 'element-plus'
import router from '../router/index'
import config from '../global/config'
import { paramsDecode } from "../utils/crypto.js";

axios.defaults.timeout = 1000 * 10;
axios.defaults.withCredentials = true;
axios.defaults.baseURL = config.BASE_URL;


/**
 * 请求前拦截
 * 用于处理需要在请求前的操作
 * axios.interceptors.request.use(
 (config) => {
        let YLJGDM = localStorage.getItem("YLJGDM");
        let params = [];
        if (YLJGDM) {
            params.push(`YLJGDM=${YLJGDM}`);
        }
        let clientId = localStorage.getItem("clientId");
        if (clientId) {
            params.push(`clientId=${clientId}`);
        }
        if (params.length) {
            params = params.join(";");
        }
        config.headers["Authorization"] = params;

        return config;
    },
 (error) => {
        return Promise.reject(error);
    }
 );
 *
 */

/**
 * 请求响应拦截
 * 用于处理需要在请求返回后的操作
 */
axios.interceptors.response.use(
    (response) => {
        const responseCode = response.status;
        // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
        // 否则的话抛出错误
        if (responseCode === 200) {
            return Promise.resolve(response);
        } else {
            return Promise.reject(response);
        }
    },
    (error) => {
        // console.log(error, 'api-67');
        if (!error.response) {
            // 请求超时状态
            if (error.message.includes("timeout")) {
                console.log("超时了");
                ElMessage.error("请求超时，请检查网络是否连接正常"); // 演示暂时注掉
            } else {
                // 可以展示断网组件
                console.log("断网了");
                ElMessage.error("请求失败，请检查网络是否已连接");
            }
        } else {
        }
        return Promise.reject(error);
    }
);
function errMessage() {
    ElMessage.closeAll();
    ElMessage({
        message: "服务异常，请检查网络或联系客服",
        type: "error",
        customClass: "pollingMsgBox",
        showClose: true,
        // onClose: this.reload,
        duration: 1500,
    });
}

function getImageUrl(url, has) {
    if(!has) {
        return  config.BASE_URL + url
    }
    return config.BASE_URL + '/api' + config.version + '/dcpc' + url
}
function getImageUrlBySign(url, params = {}) {
    params = paramsDecode(params);
    url = getUrl(url) + params;
    return config.BASE_URL + url
}
function getUrl(url) {
    return '/api' + config.version + '/dcpc' + url
}
function get(url, params={}, config = {}) {
    params = paramsDecode(params);
    url = getUrl(url) + params;
    return new Promise((resolve, reject) => {
        axios.get(url, config).then(
            (response) => {
                let res = response.data;
                if (res.code === 0) {
                    resolve(res);
                } else if (res.code === 1004) {
                    router.push({
                        path: "/login",
                    });
                } else if (res.code === 1001) {
                    reject(res);
                    errMessage();
                    console.log("status code:" + res.code, url);
                } else {
                    reject(res);
                }
            },
            (reject) => {
                console.log(url,reject, 'get');
                if (reject.status !== 0) {
                    errMessage();
                }
            }
        );
    });
}
function post(url, params, config = {}, options = {}) {
    let urlParams = paramsDecode({});
    url = getUrl(url) + urlParams;
    return new Promise((resolve, reject) => {
        axios.post(url, params, config).then(
            (response) => {
                let res = response.data;
                if (res.code === 0) {
                    resolve(res);
                } else if (res.code === 1004) {
                    router.push({
                        path: "/login",
                    });
                } else if (res.code === 1001) {
                    reject(res);
                    errMessage();
                    console.log("status code:" + res.code, url);
                } else {
                    reject(res);
                }
            },
            (reject) => {
                console.log(url,reject, 'post');
                if (reject.status !== 0) {
                    // console.log("error", reject);
                    errMessage();
                }
            }
        );
    });
}
function put(url, params = {}) {
    params = paramsDecode(params);
    url = getUrl(url) + params;
    return new Promise((resolve, reject) => {
        axios.put(url, params).then(
            response => {
                if (!response) return;
                let res = response.data;
                if (res.code === 0) {
                    resolve(response.data);
                } else if (res.code === 1004) {
                    router.push({
                        path: "/login"
                    });
                } else if (res.code === 1001) {
                    reject(res);
                    errMessage("服务异常，请检查网络或联系客服");
                    console.log("status code:" + res.code, url);
                } else if (res.code === 1006) {
                    errMessage('没有该权限！')
                } else if (res.code === 1003) {
                    errMessage(res.msg)
                } else {
                    reject(res);
                }
            },
            reject => {
                if (reject.status !== 0) {
                    console.log("error", reject);
                    errMessage("服务异常，请检查网络或联系客服");
                }
            }
        )
    })
}
function del(url, params = {}) {
    params = paramsDecode(params);
    url = getUrl(url) + params;
    return new Promise((resolve, reject) => {
        axios.delete(url, params).then(
            response => {
                if (!response) return;
                let res = response.data;
                if (res.code === 0) {
                    resolve(response.data);
                } else if (res.code === 1004) {
                    router.push({
                        path: "/login"
                    });
                } else if (res.code === 1001) {
                    reject(res);
                    errMessage("服务异常，请检查网络或联系客服");
                    console.log("status code:" + res.code, url);
                } else if (res.code === 1006) {
                    errMessage('没有该权限！')
                } else if (res.code === 1003) {
                    errMessage(res.msg)
                } else {
                    reject(res);
                }
            },
            reject => {
                if (reject.status !== 0) {
                    console.log("error", reject);
                    errMessage("服务异常，请检查网络或联系客服");
                }
            }
        )
    })
}
function getBlob(url, params={}, config = {}) {
    params = paramsDecode(params);
    url = getUrl(url) + params;
    return new Promise((resolve, reject) => {
        axios({
            method: "get",
            url,
            responseType: 'blob',
            ...config
        }).then(
            (response) => {
                resolve(response)
            },
            (reject) => {
                console.log(url,reject, 'get');
                if (reject.status !== 0) {
                    errMessage();
                }
            }
        );
    });
}


function erroring(msg = '错误信息', close = true, duration = 1500) {
    ElMessage({
        message: msg,
        type: "error",
        showClose: close,
        duration: duration,
    });
}
function warning(msg = '警告信息', close = false, duration = 1500) {
    ElMessage({
        message: msg,
        type: "warning",
        showClose: close,
        duration: duration,
    });
}
function infoing(msg = '提示信息', close = false, duration = 1500) {
    ElMessage({
        message: msg,
        type: "info",
        showClose: close,
        duration: duration,
    });
}
function successing(msg = '成功信息', close = false, duration = 1500) {
    ElMessage({
        message: msg,
        type: "success",
        showClose: close,
        duration: duration,
    });
}

function confirm(msg, config = {}) {
    console.log(msg, '255');
    let base = {
        title: '确认',
        conText: '确定',
        canText: '取消',
        type: 'warning',
        showCancel: true,
        showClose: true
    };
    base = Object.assign(base, config);
    return new Promise((resolve, reject) => {
        ElMessageBox.confirm(
            msg,
            base.title,
            {
                confirmButtonText: base.conText,
                cancelButtonText: base.canText,
                type: base.type,
                showCancelButton: base.showCancel,
                'show-close': base.showClose
            },
        ).then(() => {
            resolve()
        }).catch(() => {
            reject()
        })
    })
}

function prompt (msg, config = {}) {
    console.log(msg, '255');
    let base = {
        title: '确认',
        conText: '确定',
        canText: '取消',
        // type: 'warning',
        inputType: 'text',
        showCancel: true,
        showClose: true
    };
    base = Object.assign(base, config);
    return new Promise((resolve, reject) => {
        ElMessageBox.prompt(
            msg,
            base.title,
            {
                confirmButtonText: base.conText,
                cancelButtonText: base.canText,
                inputType: base.inputType,
                showCancelButton: base.showCancel,
                'show-close': base.showClose
            },
        ).then(({ value }) => {
            resolve(value)
        }).catch(() => {
            reject()
        })
    })
}
function com_down_file(params = {}) {
    get('/export', params).then(res => {
        successing('请求成功！')
    })
}



export {
    axios,
    get,
    getBlob,
    post,
    put,
    del,
    getUrl,
    getImageUrl,
    getImageUrlBySign,
    erroring,
    warning,
    infoing,
    successing,
    confirm,
    prompt,

    // 公共方法
    com_down_file
};